import React, { useState } from 'react';

import IllegalMoveCommentPopUp from './IllegalMoveCommentPopUp';
import SkillStamps from './SkillStamps';
import PlayAction from "../components/Talktape/MuxPlayAction";

import IosShareIcon from "@mui/icons-material/IosShare";
import { Tooltip } from "@mui/material";
import { toast } from 'react-toastify';

interface JudgeResult {
  judge: string;
  score: string;
  user_judge_id: number;
  judges_score_place: number;
  technique_score: number;
  execution_score: number;
  pointsdeduction_score: number;
  pointsdeduction_comment: string;
}

interface Result {
  performance_id: number;
  entry: number;
  performers: string;
  talktape:string;
  performance_type: string;
  program: string;
  program_skills_abhs: number;
  program_skills_abhs_mod2: number;
  program_skills_pom_straps: number;
  routine: string;
  total_scores: number;
  final_scores: number;
  judgescount: number;
  place: number;
  judges_score_place: number;
  tie_resolved_by: number;
  
  twdsc_tb1_rank_without_HL: number;
  twdsc_tb2_rank_with_HL: number;
  twdsc_tb3_total_scores_without_HL: number;
  twdsc_tb4_total_scores_with_HL: number;
  twdsc_tb5_total_technique: number;
  twdsc_tb6_total_execution: number;

  judgeResults: JudgeResult[]; // Data for the dropdown
}

interface FinalResultCardTWDShowcase {
  result: Result;
  places_to_announce: number;
}

const FinalResultCardTWDShowcase: React.FC<FinalResultCardTWDShowcase> = ({ result, places_to_announce }) => {
  //  const { performance_id, entry, program, performance_type, performers, routine, total_scores, final_scores, place, judgescount, judges_score_place, tie_resolved_by, tb1_with_hl_final_scores, tb2_technique_final_scores, tb3_execution_final_scores, judgeResults } = result;
//console.log("final result: ", result);
  const { entry, program, performance_type, performers, talktape, routine, final_scores, place, judgescount, tie_resolved_by, twdsc_tb1_rank_without_HL, twdsc_tb2_rank_with_HL, twdsc_tb3_total_scores_without_HL, twdsc_tb4_total_scores_with_HL, twdsc_tb5_total_technique, twdsc_tb6_total_execution, judgeResults } = result;

  //void performers;
  void judgescount;
  
  //console.log(performance_id, total_scores, judges_score_place );
  // Internal state for dropdown visibility
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  // Toggle the dropdown visibility
  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  const [isIllegalMoveCommentPopUpOpen, setIllegalMoveCommentPopUpOpen] = useState<boolean>(false);
  const handleShowComment = () => {
    setIllegalMoveCommentPopUpOpen(true);
    //alert("comment..");
  };
  const handleCloseComment = () => {
    setIllegalMoveCommentPopUpOpen(false);
  };

  const isTopPlace = place <= places_to_announce;
  
  const places = judgeResults.map(j => Number(j.judges_score_place));
  const lowIndex = judgeResults.findIndex(j => Number(j.judges_score_place) === Math.min(...places));
  const highIndex = judgeResults.findIndex(j => Number(j.judges_score_place) === Math.max(...places));
  
  const judgesscores = judgeResults.map(j => Number(j.score));
  const lowscoreIndex = judgeResults.findIndex(j => Number(j.score) === Math.min(...judgesscores));
  const highscoreIndex = judgeResults.findIndex(j => Number(j.score) === Math.max(...judgesscores));

  const handleShare = (talktapeId: string | number) => {
    const shareUrl = `${window.location.origin}/talktape/${talktapeId}`;
    navigator.clipboard.writeText(shareUrl).then(() => {
      toast.info("Link copied to clipboard!");
    }).catch(() => {
      toast.error("Failed to copy link.");
    });
  };

  const canPlaybackTalktape = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m:any) => m.title.toLowerCase() === "talktape")?.ModulesPermissions?.view;
  console.log("canPlaybackTalktape showcase : " + canPlaybackTalktape);

  return (
    <div>
      {/* Carousel Div */}
      <div className="carousel" onClick={toggleDropdown}>
        <div className={`list ${isTopPlace ? 'highlight' : ''}`} style={{ alignItems:"normal"}}> 
          {/* Apply highlight class conditionally */}
          <div className="entry-number">
            <h5 className="performance-list-text">{entry}</h5>
          </div>
          <div className="program-or-performer">
            <h5 className="performance-list-text">
              {performance_type === 'twd' ? (
                program
              ) : performance_type === 'sds' ? (
                <>
                <div>
                  {Array.isArray(performers) && performers.length > 0 ? (
                    performers.map((performer: { first_name: string, last_name: string }, index: number) => (
                      <div key={index}>
                        {performer.first_name} {performer.last_name}
                      </div>
                    ))
                  ) : (
                    'No performers available'
                  )}
                </div>
              </>
              ) : (
                'No data available'
              )}
              <SkillStamps result={result} />
            </h5>
            
          </div>          
          <div className="final-place">
            <h5 className="performance-list-text">
              <strong>{place}</strong>
            </h5>
          </div>
          <div className="final-place ribbon">
            <h5 className="performance-list-text">
              <strong>
                {final_scores >= 0 && final_scores <= 99
                  ? 'S'
                  : final_scores >= 100 && final_scores <= 149
                  ? 'G'
                  : final_scores >= 150 && final_scores <= 199
                  ? 'HG'
                  : final_scores >= 200 && final_scores <= 249
                  ? 'P'
                  : final_scores >= 250 && final_scores <= 300
                  ? 'DP'
                  : 'No Ribbon'}
              </strong>
            </h5>
          </div>
          <div className="routine-name">
            <h5 className="performance-list-text">{routine}</h5>
              <div className=".placements-talktape-play-action">
                {canPlaybackTalktape && Array.isArray(talktape) && talktape[0]?.status === "ready" ? (
                    <div>
                      <PlayAction item={talktape[0]} />                

                      <Tooltip title="Share Talktape">
                        <span onClick={() => handleShare(talktape[0]?.id)} style={{ cursor: "pointer", color: "#000", verticalAlign: "text-bottom", paddingLeft: "5px" }}>
                        <IosShareIcon fontSize="small" />
                        </span>
                      </Tooltip>
                  </div>
                  
                ) : null}
              </div>
          </div>
          <div className="total-score">
            <h5 className="performance-list-text">
              {/* <strong>{final_scores}</strong> */}
              <strong>{twdsc_tb1_rank_without_HL}</strong>
            </h5>
          </div>
          
          <div className="dropdown-arrow">
            <img
              src="images/down-arrow-icon.png"
              loading="lazy"
              alt="arrow icon"
              className={`image-6 ${isDropdownOpen ? 'flipped' : ''}`}
            />
          </div>

          <div className="illegalmove">
            {result?.judgeResults[0]?.pointsdeduction_score && (
              <img src="images/IllegalMoveIcon.png" loading="lazy" alt="" className="image-7" 
              onClick={(e) => {
                e.stopPropagation(); // Prevent toggleExpansion from being triggered
                handleShowComment();
              }}
              />
            )}
          </div>

          {tie_resolved_by >= 1 && (
            <a href="#" className="button-3 w-button">Tie Breaker</a>
          )}
        </div>
      </div>
      {/* Drop-down List */}
      {isDropdownOpen && (
        <div className="drop-down-list-new active">
          <div className="judge-result">
              {judgeResults.map((judgeResult, idx) => (
                <div className="judge-final-result" key={idx}>
                  <h5
                    className={`performance-list-text ${
                      (idx === highIndex || idx === lowIndex) ? 'strikethrough' : ''
                    }`}
                  >
                    {judgeResult.judge}<br />
                    {judgeResult.judges_score_place}
                  </h5>
                </div>
              ))}
            <div className="judge-final-result">
              <h5 className={`performance-list-text`}>
              Rank Total<br/>(No H/L)<br />
                {twdsc_tb1_rank_without_HL}
              </h5>
            </div>
          </div>
          
                {tie_resolved_by >= 1 && (
                  <div className="judge-result judge-result-tie-break">
                    {judgeResults.map((judgeResult, idx) => (
                      <div className="judge-final-result" key={idx}>
                        <h5 className="performance-list-text">
                          {judgeResult.judge}<br />
                          {judgeResult.judges_score_place}
                        </h5>
                      </div>
                    ))}
                    <div className="judge-final-result">
                      <h5 className="performance-list-text">
                        Rank Total<br />
                        {twdsc_tb2_rank_with_HL}
                      </h5>
                    </div>
                  </div>
                )}

                {tie_resolved_by >= 2 && (
                  <div className="judge-result judge-result-tie-break">
                    {judgeResults.map((judgeResult, idx) => (
                      <div className="judge-final-result" key={idx}>
                        <h5
                          className={`performance-list-text ${
                            (idx === highscoreIndex || idx === lowscoreIndex) ? 'strikethrough' : ''
                          }`}
                        >
                          {judgeResult.judge}<br />
                          {judgeResult.score}
                        </h5>
                      </div>
                    ))}
                    <div className="judge-final-result">
                      <h5 className="performance-list-text">
                        Total Points<br />(No H/L)<br/>
                        {twdsc_tb3_total_scores_without_HL}
                      </h5>
                    </div>
                  </div>
                )}

                {tie_resolved_by >= 3 && (
                  <div className="judge-result judge-result-tie-break">
                    {judgeResults.map((judgeResult, idx) => (
                      <div className="judge-final-result" key={idx}>
                        <h5 className="performance-list-text">
                          {judgeResult.judge}<br />
                          {judgeResult.score}
                        </h5>
                      </div>
                    ))}
                    <div className="judge-final-result">
                      <h5 className="performance-list-text">
                        Total Points<br />
                        {twdsc_tb4_total_scores_with_HL}
                      </h5>
                    </div>
                  </div>
                )}

                {tie_resolved_by >= 4 && (
                  <div className="judge-result judge-result-tie-break">
                    {judgeResults.map((judgeResult, idx) => (
                      <div className="judge-final-result" key={idx}>
                        <h5 className="performance-list-text">
                          {judgeResult.judge}:<br />
                          {judgeResult.technique_score}
                        </h5>
                      </div>
                    ))}
                    <div className="judge-final-result">
                      <h5 className="performance-list-text">
                        Technique Total<br />
                        {twdsc_tb5_total_technique}
                      </h5>
                    </div>
                  </div>
                )}

                {tie_resolved_by >= 5 && (
                  <div className="judge-result judge-result-tie-break">
                    {judgeResults.map((judgeResult, idx) => (
                      <div className="judge-final-result" key={idx}>
                        <h5 className="performance-list-text">
                          {judgeResult.judge}:<br />
                          {judgeResult.execution_score}
                        </h5>
                      </div>
                    ))}
                    <div className="judge-final-result">
                      <h5 className="performance-list-text">
                        Execution Total<br />
                        {twdsc_tb6_total_execution}
                      </h5>
                    </div>
                  </div>
                )}
  
        </div>
      )}

      <IllegalMoveCommentPopUp
        isOpen={isIllegalMoveCommentPopUpOpen}
        onClose={handleCloseComment}
        show_comment={result?.judgeResults[0]?.pointsdeduction_comment}
         />
    </div>
  );
};

export default FinalResultCardTWDShowcase;